type DetermineIsButtonDisabled = {
  isDirty: boolean;
  isValid: boolean;
};

export const determineIsButtonDisabled = ({
  isDirty,
  isValid,
}: DetermineIsButtonDisabled): boolean => !isDirty || (isDirty && !isValid);
